import React from "react";
import Signin from "../components/login/Signin";
import ForgotPwdOne from "../components/login/ForgotPwdOne";
import Alert from "../components/Alert";
import ForgotPwdTwo from "../components/login/ForgotPwdTwo";
import Signup from "../components/login/Signup";
import imgBg from "../images/parc/IMG_4132.jpg";

class Login extends React.Component {
    state = {
        alert: {
            active: false,
            type: '',
            title: '',
            desc: ''
        },
        step: "signin",
        emailForgot: ''
    }

    componentDidMount() {
        document.title = "Connexion - DiscovRide | Calendriers d'affluence, Temps d'attente de parcs d'attractions (Futuroscope, Parc Asterix...)";
        this.props.handleMenu(false);
        if (
            localStorage.getItem('userId') != undefined &&
            localStorage.getItem('userId') != "null" &&
            localStorage.getItem('userCred') != undefined &&
            localStorage.getItem('userCred') != "null"
        ) {
            window.location.href = "/";
        }
    }

    render() {
        return <div className="blogp__main plogin" style={{backgroundImage: `url('${imgBg}')`}}>
            {/** Mot de passe oublié - 1 **/}
            <ForgotPwdOne
                changeAlert={(el) => this.setState({alert: el})}
                otherClass={
                    this.state.step == "forgot-one" ?
                        null : 'prev'
                }
                changeStep={(el) => this.setState({step: el})}
                changeEmailForgot={(el) => this.setState({emailForgot: el})}
            />

            {/** Mot de passe oublié - 2 **/}
            <ForgotPwdTwo
                changeAlert={(el) => this.setState({alert: el})}
                otherClass={
                    this.state.step == "forgot-two" ?
                        null : 'prev'
                }
                changeStep={(el) => this.setState({step: el})}
                email={this.state.emailForgot}
            />

            {/** Signin **/}
            <Signin
                changeAlert={(el) => this.setState({alert: el})}
                otherClass={
                    this.state.step == "signin" ?
                        null: (
                            (this.state.step == "forgot-one" || this.state.step == "forgot-two") ?
                                "next" : "prev"
                        )
                }
                changeStep={(el) => this.setState({step: el})}
                idtt={this.props.idtt}
            />

            {/** Signup **/}
            <Signup
                changeAlert={(el) => this.setState({alert: el})}
                otherClass={
                    this.state.step == "signup" ?
                        null : 'next'
                }
                changeStep={(el) => this.setState({step: el})}
            />

            <Alert alert={this.state.alert}/>
        </div>
    }
}

export default Login;